import type { LucideIcon } from 'lucide-react';

export type MenuItem = {
    id: NavPathOverrideEnum;
    name: string;
    href?: string;
    icon: LucideIcon;
    subItems?: MenuSubItem[];
    count?: number;
};

export type MenuSubItem = {
    id: NavPathOverrideEnum;
    name: string;
    href: string;
    icon: LucideIcon;
};

export type MenuGroup = {
    /** Identity/key for the group (React key + collapse-state key). */
    id: string;
    /** Undefined renders the items as a bare list with no header. */
    label?: string;
    items: MenuItem[];
};

export enum NavPathOverrideEnum {
    HOME = 'home',
    CUSTOMERS = 'customers',
    INVENTORY = 'inventory',
    SALES = 'sales',
    SALES_INSIGHTS = 'sales_insights',
    SALES_QUOTES = 'sales_quotes',
    SALES_ORDERS = 'sales_orders',
    EXPLORER = 'explorer',
    TASKS = 'tasks',
    SALES_DRAFTS = 'drafts',
    TRANSACTIONS = 'transactions',
    EVENTS = 'events',
    TEAM = 'team',
    ACTIVITIES = 'activities',
}
